import React from "react";
import { useEffect, useState } from "react"
import { Container, Grid, Card, CardMedia, CardContent, Typography, Button, Box } from "@mui/material"
import { useNavigate } from "react-router-dom"

import blogsData from "../Utils/blogStorage"
import BgContainer2 from "./CommonC/BgContainer2";
import BlogNavbar from "./CommonC/BlogNavbar";
import Modal from "@mui/material/Modal";
import { Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Projectcolors from "../Utils/Colors";
import selexmathimg from "../images/SelexSIM.png";
import Selexlogo from "../images/SelexMB Final.png";
import optimizelogo from "../images/logooptimizegsfinal.png";
import selexsuite from "../images/SelexSuite copy.png";
import Selexrisk from "../images/SelexRISK2.png";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";
import { TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";



const stylec = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 480,
  bgcolor: "white",
  border: "2px solid #000",
  p: 4,
  display: "block",
};



function Projects(){

const navigate = useNavigate()

const handleOpenc = () => setOpenc(true);
const handleOpen = () => setOpen(true);
const [openc, setOpenc] = React.useState(false);
const [open, setOpen] = React.useState(false);
const [loader, setLoader] = React.useState(false);
const [search, setSearch] = useState("");
const [blog, setBlog] = useState({});

  const handleClosec = () => setOpenc(false);
  const [ProjectsArray, setProjectsArray] = React.useState([]);

  useEffect(async () => {
      await getAllprojects();
    }, []);

    const getAllprojects = async () => {
          try {
            setLoader(true)
            let result = await fetch(`${baseURL}/getallprojects`);
            result = await result.json();
            if (result.code) {
              const blogdata = [];
              result.data.map((item, idx) => {
                setLoader(false)
                return blogdata.push({
                  id: item.blog_id,        
                  title:item.title,
                  slug:item.slug,
                  description:item.description,
                  author:item.author,
                  date:item.date,
                  image:item.image,
                  content:item.content,
                  editBlogState: false,
                });
              });
              setLoader(false)
              setProjectsArray(result.data);
      
              return;
            }
            alert("There was some error");
            setLoader(false)
          } catch (error) {
            setLoader(false)
            console.log("error", error);
          }
        };
  const filteredProjects = ProjectsArray.filter((project) =>
  project.title.toLowerCase().includes(search.toLowerCase()) ||
  project.description.toLowerCase().includes(search.toLowerCase()) ||
  project.author.toLowerCase().includes(search.toLowerCase())
);


return (
  <Box
    sx={{
      minHeight: "100vh",
      background:"#fff",
      overflowX: "hidden",
    }}
  >
    <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

    <Container maxWidth="xl" sx={{ pt: { xs: 2, md: 4 }, pb: 6 }}>
      {/* HEADER */}
      <Box sx={{ textAlign: "center", mb: 5 }}>
        <Typography
          sx={{
            color: "#9e0b22",
            fontSize: 20,
            fontWeight: 950,
            letterSpacing: 1.4,
            textTransform: "uppercase",
            mb: 1,
          }}
        >
          Projects
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: 30, md: 46 },
            fontWeight: 950,
            color: "#061d34",
            letterSpacing: "-1.6px",
            mb: 1.5,
          }}
        >
          Explore Engineering & AI Projects
        </Typography>

        <Typography
          sx={{
            color: "#64748b",
            maxWidth: 760,
            mx: "auto",
            lineHeight: 1.75,
            fontSize: 15,
          }}
        >
          Browse engineering projects, AI workflows, process simulation studies,
          and industrial case studies from OptimizeXP.
        </Typography>
      </Box>

      {/* SEARCH */}
      <Box
        sx={{
          maxWidth: 760,
          mx: "auto",
          mb: 5,
        }}
      >
        <TextField
          fullWidth
          placeholder="Search projects..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            bgcolor: "#fff",
            borderRadius: "18px",
            boxShadow: "0 14px 38px rgba(6,29,52,0.08)",
            "& .MuiOutlinedInput-root": {
              borderRadius: "18px",
              fontSize: "14px",
              "& fieldset": {
                borderColor: "rgba(0,120,201,0.16)",
              },
              "&:hover fieldset": {
                borderColor: "#0078c9",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#0078c9",
              },
            },
          }}
        />
      </Box>

      {/* PROJECT CARDS */}
      <Grid container spacing={3}>
        {filteredProjects.map((project) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={project.id}>
            <Card
              sx={{
                height: "100%",
                borderRadius: "30px",
                overflow: "hidden",
                background: "rgba(255,255,255,0.94)",
                border: "1px solid rgba(0,120,201,0.13)",
                boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
                transition: "0.35s ease",
                position: "relative",
                "&:hover": {
                  transform: "translateY(-10px)",
                  boxShadow: "0 30px 75px rgba(0,120,201,0.18)",
                  borderColor: "#0078c9",
                },
              }}
            >
              <Box sx={{ position: "relative", height: 190, overflow: "hidden" }}>
                <CardMedia
                  component="img"
                  image={project.image}
                  height="190"
                  sx={{
                    objectFit: "cover",
                    transition: "0.4s ease",
                    ".MuiCard-root:hover &": {
                      transform: "scale(1.06)",
                    },
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(to top, rgba(6,29,52,0.72), transparent 65%)",
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    top: 14,
                    right: 14,
                    bgcolor: "#fff",
                    px: 1.6,
                    py: 0.6,
                    borderRadius: "999px",
                    fontSize: 12,
                    fontWeight: 900,
                    color: "#9e0b22",
                    border: "1px solid rgba(158,11,34,0.16)",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
                  }}
                >
                  Project
                </Box>
              </Box>

              <CardContent sx={{ p: 3 }}>
                <Typography
                  sx={{
                    fontSize: 19,
                    fontWeight: 950,
                    color: "#061d34",
                    lineHeight: 1.25,
                    minHeight: 48,
                    mb: 1.5,
                  }}
                >
                  {project.title}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 14,
                    color: "#64748b",
                    lineHeight: 1.75,
                    minHeight: 74,
                    mb: 2,
                  }}
                >
                  {project.description}
                </Typography>

                <Divider sx={{ my: 2, borderColor: "rgba(0,120,201,0.12)" }} />

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                    mb: 2,
                  }}
                >
                  <Typography sx={{ fontSize: 12, color: "#061d34", fontWeight: 800 }}>
                    {project.author}
                  </Typography>

                </Box>

                <Button
                  fullWidth
                  onClick={() => navigate(`/projects/${project.slug}`)}
                  sx={{
                    mt: 1,
                    py: 1.2,
                    borderRadius: "999px",
                    textTransform: "none",
                    fontSize: 14,
                    fontWeight: 900,
                    color: "#fff",
                    background: "linear-gradient(135deg, #0078c9, #005b98)",
                    boxShadow: "0 14px 30px rgba(0,120,201,0.24)",
                    "&:hover": {
                      background: "linear-gradient(135deg, #9e0b22, #75081a)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 18px 38px rgba(158,11,34,0.26)",
                    },
                  }}
                >
                  Read More
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>

    {loader && <GlobalLoader />}
  </Box>
);
}

export default Projects